import React from 'react';

import {MODEL_RUN_SOURCE} from 'constants/AnalyticsConstants';
import Modal from 'ui-library/modals/Modal';

import {getAvailableStructurePredictionModels, getModelDisplayName} from '../ScientificModelConstants';
import {SCIENTIFIC_MODEL} from '../ScientificModelConstants';
import {BoltzGenInputForm} from './boltzgen/BoltzGenInputForm';
import StructurePredictionForm from './structure-prediction/StructurePredictionForm';

export interface ScientificModelInputFormProps {
  model: string;
  onRequestClose: () => void;
}

export function ScientificModelInputForm({
  model,
  onRequestClose,
}: ScientificModelInputFormProps): JSX.Element {
  if (model === SCIENTIFIC_MODEL.BOLTZGEN) {
    return <BoltzGenInputForm onRequestClose={onRequestClose} source={MODEL_RUN_SOURCE.MODEL_HUB_UI} />;
  } else if (getAvailableStructurePredictionModels().includes(model)) {
    return (
      <StructurePredictionForm
        onSubmit={onRequestClose}
        startingModel={model}
        source={MODEL_RUN_SOURCE.MODEL_HUB_UI}
      />
    );
  } else {
    throw new Error(`Unsupported model type: ${model}`);
  }
}

export interface ScientificModelInputFormModalProps {
  model: string;
  onRequestClose: () => void;
}

export function ScientificModelInputFormModal({
  model,
  onRequestClose,
}: ScientificModelInputFormModalProps): JSX.Element {
  return (
    <Modal
      title={`Configure ${getModelDisplayName(model)}`}
      onRequestClose={onRequestClose}
      closeableOnBackgroundClick={true}
      large={true}
      fullHeight={true}
      bodyPadded={false}
    >
      <ScientificModelInputForm model={model} onRequestClose={onRequestClose} />
    </Modal>
  );
}
